import { createSelector } from 'reselect'
import * as R from 'ramda'

import { FILE_TYPES } from './constants'
import { entitySelector, resultsSelector } from 'containers/Entity/selectors'
import { formattedFileSelector } from 'containers/Project/FileSection/selectors'

const filesSelector = createSelector(
  formattedFileSelector,
  R.filter(R.compose(
    R.flip(R.contains)(FILE_TYPES),
    R.prop('fileType')
  ))
)

export {
  filesSelector
}
